import { ComponentProps, useState } from "react";
import { StyleSheet, TextInput, TextInputProps, TextStyle, View, ViewStyle, StyleProp, Platform } from "react-native";
import { useTheme } from "@/hooks/useTheme";
import { MaterialIcons } from "@expo/vector-icons";

type Props = TextInputProps & {
  icon?: ComponentProps<typeof MaterialIcons>["name"];
  iconPosition?: "left" | "right";
  containerStyle?: StyleProp<ViewStyle>;
  style?: TextStyle;
};

export default function Input({ icon, iconPosition = "left", containerStyle, style, onFocus, onBlur, ...rest }: Props) {
  const { colors } = useTheme();
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e: any) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const handleBlur = (e: any) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const borderColor = isFocused ? colors.primary : colors.border;

  return (
    <View style={[styles.container, { borderColor }, containerStyle]}>
      {icon && iconPosition === "left" && (
        <MaterialIcons
          name={icon}
          size={20}
          color={isFocused ? colors.primary : colors.placeholder}
          style={styles.icon}
        />
      )}

      <TextInput
        autoFocus={false}
        autoComplete="off"
        style={[styles.input, { color: colors.text }, style]}
        placeholderTextColor={colors.placeholder}
        onFocus={handleFocus}
        onBlur={handleBlur}
        {...rest}
      />

      {icon && iconPosition === "right" && (
        <MaterialIcons
          name={icon}
          size={20}
          color={isFocused ? colors.primary : colors.placeholder}
          style={styles.icon}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: StyleSheet.hairlineWidth,
    height: 45,
    borderRadius: 8,
    paddingLeft: 8,
  },
  input: {
    borderRadius: 8,
    height: 40,
    width: "100%",
    flex: 1,
    fontSize: 16,
    borderWidth: 0,
    borderColor: "red",
    ...(Platform.OS === "web" ? { outlineStyle: "none" } : {}),
  },
  icon: {
    marginHorizontal: 6,
  },
});
